__turbopack_context__.v({
  "appear-slide-left": "Locations-module-scss-module__igoi5G__appear-slide-left",
  "bounceTwice": "Locations-module-scss-module__igoi5G__bounceTwice",
  "fade-in-bottom": "Locations-module-scss-module__igoi5G__fade-in-bottom",
  "fade-in-left": "Locations-module-scss-module__igoi5G__fade-in-left",
  "fade-in-right": "Locations-module-scss-module__igoi5G__fade-in-right",
  "fadeIn": "Locations-module-scss-module__igoi5G__fadeIn",
  "link": "Locations-module-scss-module__igoi5G__link",
  "loader": "Locations-module-scss-module__igoi5G__loader",
  "locations": "Locations-module-scss-module__igoi5G__locations",
  "puff-in-center": "Locations-module-scss-module__igoi5G__puff-in-center",
  "puff-in-left": "Locations-module-scss-module__igoi5G__puff-in-left",
  "pulse": "Locations-module-scss-module__igoi5G__pulse",
  "pulse-contact": "Locations-module-scss-module__igoi5G__pulse-contact",
  "shake-bottom": "Locations-module-scss-module__igoi5G__shake-bottom",
  "slide-again": "Locations-module-scss-module__igoi5G__slide-again",
  "slide-in-right": "Locations-module-scss-module__igoi5G__slide-in-right",
  "stepContent-entrance": "Locations-module-scss-module__igoi5G__stepContent-entrance",
  "text": "Locations-module-scss-module__igoi5G__text",
});
